import { render, staticRenderFns } from "./ProcessoAssinatura.vue?vue&type=template&id=39618016&scoped=true"
import script from "./ProcessoAssinatura.vue?vue&type=script&lang=js"
export * from "./ProcessoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./ProcessoAssinatura.vue?vue&type=style&index=0&id=39618016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39618016",
  null
  
)

export default component.exports